// src/app/shared/services/shared-date.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedDateService {

  private selectedDateSource = new BehaviorSubject<Date>(new Date());
  
  selectedDate$ = this.selectedDateSource.asObservable();

  private resetDate = new BehaviorSubject<boolean>(false);
  
  resetDate$ = this.resetDate.asObservable();

  private selectedScenarioSource = new BehaviorSubject<string>('Prévision pluie médiane');
  
  selectedScenario$ = this.selectedScenarioSource.asObservable();

  updateSelectedDate(date: Date): void {
    this.selectedDateSource.next(date);
  }

  updateResetDate(change: boolean): void {
    this.resetDate.next(change);
  }

  getResetDateValue(): boolean {
    return this.resetDate.getValue();
  }

  updateSelectedScenario(scenario: string): void {
    this.selectedScenarioSource.next(scenario);
  }

  
  isDateToday(date: Date): boolean {
    // Si la date est null, undefined, ou n'est pas un objet Date valide
    if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
      return false;
    }
    const today = new Date();
    return date.getDate() === today.getDate() &&
           date.getMonth() === today.getMonth() &&
           date.getFullYear() === today.getFullYear();
  }

  isDateInFuture(date: Date): boolean {
    const currentDate = new Date(); 
    return date > currentDate;
  }
}
